<template>
<a :href="isWeixin && (isList || isRoom || isLiPinKa || isDsk) ? '' : data.clickUrl"
   :data-scp="scp"
   :data-bk="bk"
   @click="goApp($event)">
	<div v-if="isWeixin && (isList || isRoom || isLiPinKa || isDsk)" v-html="wxapp">

	</div>
	<div v-else>
		<img :style="style"
		     :width="width"
		     :height="height"
		     :src="data.imageUrl" alt="">
	</div>
</a>
</template>

<script>
import {maple, domain, app} from 'tgPage';

let isWeixin = maple.device.weixin
	, protocol = location.protocol
	;

export default {
	props: {
		data: {
			type: Object
			, default: null
		}
		, scp: {
			type: String
			, default: ''
		}
		, bk: {
			type: String
			, default: ''
		}
		, width: {
			type: Number
		}
		, height: {
			type: Number
		}
		, style: {
			type: String
			, default: 'max-width:100%;'
		}
	}
	, data(){
		return {
			isWeixin
			, isHybrid: maple.cookie('hybrid') === 'true'
			, webcast: {
				userName: domain.webcast.userName
				, list: `${domain.webcast.path}.html`
				, room: `${domain.webcast.room}.html`
				, lipinka: `${domain.webcast.lipinka}.html`,
                dsCard: `${domain.webcast.dsCard}.html`
			}
			, protocol
			, roomId: ''
		};
	}
	, methods: {
		goApp($event){
			if( this.isHybrid ){
				$event.preventDefault();

				app.startWxapp({
					userName: domain.userName
					, path: this.data.clickUrl
				});
			}
		}
	}
	, watch: {
		data: {
			handler(newValue){
				if( newValue ){
					this.show = true;

					if( this.isRoom ){
						let rs = /webcast\.html.*?#\/room\?roomId=([^&]*)/.exec( newValue.clickUrl )
						;

						if( rs ){
							this.roomId = rs[1];
						}
					}
				}
			}
			, immediate: true
		}
	}
	, computed: {
		isList(){
			return /webcast\.html.*?#\/publicity/.test( this.data.clickUrl );
		}
		, isRoom(){
			return /webcast\.html.*?#\/room/.test( this.data.clickUrl );
		}
		, isLiPinKa(){  // 礼品卡
			return /lipinka\.html/.test( this.data.clickUrl );
		},
        isDsk(){
            return /dsCard\.html/.test( this.data.clickUrl );
        }
		, path(){
			if( this.isList ){
				return this.webcast.list;
			}

			if( this.isRoom ){
				return `${this.webcast.room}?roomId=${this.roomId}`;
			}

			if( this.isLiPinKa ){
				return this.webcast.lipinka;
			}

            if( this.isDsk ){
                return this.webcast.dsCard;
            }
		}
		, wxapp(){
			return `<wx-open-launch-weapp
	                      username="${this.webcast.userName}"
	                      path="${this.path}">
	<script type="text/wxtag-template">
		<img style="${this.style || ''}"
		     width="${this.width || ''}"
		     height="${this.height || ''}"
		     src="${this.protocol}${this.data.imageUrl}" alt="">
	<\/script>
<\/wx-open-launch-weapp>`
		}
	}
}
</script>